import { BecomePartnerCard } from './cards/become-partner-card.component';
import { ProfessionalContactCard } from './cards/professional-contact-card.component';
import { PartnerSimplifyScheduleSection } from './partner-simplify-schedule-section.component';

import { ContentContainer } from '@/components/ui/content-container.component';

export const FaqProfessionalTabContent = () => {
  return (
    <>
      <ContentContainer className="lg:max-w-3xl mb-6 lg:mb-10">
        <div className="flex flex-col gap-5">
          <BecomePartnerCard />
          <ProfessionalContactCard />
        </div>
      </ContentContainer>
      <PartnerSimplifyScheduleSection />
    </>
  );
};
